import { CaseTopic } from '@/@types/generated'
import { FlameIcon } from 'lucide-react'
import { CaseTopicsProvider, useCaseTopics } from '../hooks/case-topics'
import SelectTypeButton, { SelectTypeButtonProps } from './SelectTypeButton'

interface CaseTopicButtonProps {
  value: CaseTopic | null
  onChange: SelectTypeButtonProps<CaseTopic>['onChange']
  disabled?: boolean
}

export function CaseTopicButton({ ...props }: CaseTopicButtonProps) {
  return (
    <CaseTopicsProvider>
      <Inner {...props} />
    </CaseTopicsProvider>
  )
}

function Inner({ value, disabled, onChange }: CaseTopicButtonProps) {
  // Hooks
  const { caseTopics } = useCaseTopics()

  return (
    <SelectTypeButton
      label="Hot Topic"
      options={caseTopics}
      value={value}
      valueIcon={<FlameIcon className="stroke-orange-600" />}
      disabled={disabled}
      onChange={onChange}
    />
  )
}
